import type {Metadata} from '../types';

export function getWorkExpressionIds(data: Metadata, workId: string): string[] {
  return data.expressions.filter(e => e.workId === workId).map(e => e.id);
}
